import { useState, useEffect } from "react";
import greenDot from "@/assets/green-dot.png";
import logo from "@/assets/logo.png";
import NextButton from "../buttons/NextButton";
import FooterTablet from "./FooterTablet";
import FooterDesktop from "./FooterDesktop";
import FooterPhone from "./FooterPhone";
import MarqueeText from "../MarqueeText";

const Footer: React.FC = () => {
  const [screenType, setScreenType] = useState<'desktop' | 'tablet' | 'phone' | null>(null);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (!isHydrated) return;
    
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width > 992) {
        setScreenType('desktop');
      } else if (width > 576) {
        setScreenType('tablet');
      } else {
        setScreenType('phone');
      }
    };

    checkScreenSize(); // Initial check
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, [isHydrated]);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderFooter = () => {
    switch (screenType) {
      case 'phone':
        return (
          <FooterPhone
            greenDot={greenDot}
            logo={logo}
            NextButton={NextButton}
            handleScrollToTop={handleScrollToTop}
          />
        );
      case 'tablet':
        return (
          <FooterTablet
            greenDot={greenDot}
            logo={logo}
            NextButton={NextButton}
            handleScrollToTop={handleScrollToTop}
          />
        );
      case 'desktop':
      default:
        return (
          <FooterDesktop
            greenDot={greenDot}
            logo={logo}
            NextButton={NextButton}
            handleScrollToTop={handleScrollToTop}
          />
        );
    }
  };

  // Prevent hydration mismatch by showing default until hydrated
  if (!isHydrated) {
    return (
      <>
        <MarqueeText />
        <FooterDesktop
          greenDot={greenDot}
          logo={logo}
          NextButton={NextButton}
          handleScrollToTop={handleScrollToTop}
        />
      </>
    );
  }

  return (
    <>
      <MarqueeText />
      {renderFooter()}
    </>
  );
};

export default Footer;